import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ProblemSolution() {
  return <section className="flex flex-col lg:flex-row min-h-[80vh]" data-id="element-123">
      {/* Problem Side */}
      <motion.div initial={{
      opacity: 0,
      x: -50
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="w-full lg:w-1/2 bg-charcoal py-20 px-8 lg:px-16 flex flex-col justify-center relative z-10" data-id="element-124">
        <div className="max-w-xl mx-auto lg:ml-auto lg:mr-10" data-id="element-125">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-6" data-id="element-126">
            High-Achieving But <span className="text-red-500/80" data-id="element-127">Hollow</span>
          </h2>
          <div className="h-1 w-20 bg-red-900/50 mb-10" data-id="element-128"></div>

          <ul className="space-y-6" data-id="element-129">
            {['Burnout that no vacation can fix', 'Relationships hanging by a thread', 'Spiritual emptiness masked by success', "Self-sabotage cycles you can't break", 'Numbing with substances, work, or both'].map((item, i) => <li key={i} className="flex items-start" data-id="element-130">
                <X className="text-red-500/60 w-6 h-6 mr-4 mt-1 flex-shrink-0" data-id="element-131" />
                <span className="text-gray-400 text-lg" data-id="element-132">{item}</span>
              </li>)}
          </ul>
        </div>
      </motion.div>

      {/* Solution Side */}
      <motion.div initial={{
      opacity: 0,
      x: 50
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="w-full lg:w-1/2 bg-dark py-20 px-8 lg:px-16 flex flex-col justify-center relative" data-id="element-133">
        {/* Diagonal Divider (Desktop only) */}
        <div className="hidden lg:block absolute top-0 bottom-0 -left-12 w-24 bg-dark transform -skew-x-6 z-0 border-l border-dark-lighter" data-id="element-134"></div>

        <div className="max-w-xl mx-auto lg:mr-auto lg:ml-10 relative z-10" data-id="element-135">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-6" data-id="element-136">
            Grounded, Present &{' '}
            <span className="text-gold" data-id="element-137">Purpose-Driven</span>
          </h2>
          <div className="h-1 w-20 bg-gold mb-10" data-id="element-138"></div>

          <ul className="space-y-6" data-id="element-139">
            {['Emotional regulation that holds under pressure', 'Authentic connection with the people who matter', "Faith-aligned success that doesn't require self-destruction", "A legacy you're actually proud of", 'Freedom from the chains of addiction and shame'].map((item, i) => <li key={i} className="flex items-start" data-id="element-140">
                <Check className="text-gold w-6 h-6 mr-4 mt-1 flex-shrink-0" data-id="element-141" />
                <span className="text-gray-300 text-lg" data-id="element-142">{item}</span>
              </li>)}
          </ul>
        </div>
      </motion.div>
    </section>;
}